import React, { useState } from "react";
import ReactDOM from "react-dom";
import { history } from "../../history/history";
import DatePicker from "react-datepicker";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment";
var accdetails = require("../../../config/accdetails.json")

//Return the PaymentModel for creating a campaign or not
const PaymentModel = ({
  isShowing,
  hide,
  makePayment,
  submitTransactionDetails,
  savedraft,
  payamount
}) => {
  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [paymentmode, setpaymentmode] = useState("Online");
  const [showTransactionDetails, setShowTransactionDetails] = useState(false);
  const [refno, setrefno] = useState("");
  const [ifsc, setifsc] = useState("");
  const [accountno, setaccountno] = useState("");
  const [amount, setamount] = useState("");
  const [paymentdate, setpaymentdate] = useState("");

  const handleToastError = (error) => {
    toast.error(error, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: false,
      hideProgressBar: true,
      toastId: "1",
    });
  };

  const proceedPayment = () => {
    if (paymentmode === "Online") {
      makePayment();
    } else {
      setShowPaymentDetails(true);
    }
  };

  const submitDetails = (e) => {
    debugger
    e.preventDefault();
    if (!ifsc) {
      handleToastError("Please enter the bank ifsc code");
      return;
    }
    if (!accountno) {
      handleToastError("Please enter the bank account number");
      return;
    }
    if (!paymentdate) {
      handleToastError("Please enter the payment date");
      return;
    }
    if (!refno) {
      handleToastError("Please enter the bank reference number");
      return;
    }
    if (!amount) {
      handleToastError("Please enter the transferred amount");
      return;
    }
    if(amount !== payamount.toString()){
      handleToastError(`Please transfer the amount of Rs ${payamount} and submit the details`);
      return;
    }
    debugger;
    submitTransactionDetails({
      refno,
      ifsc,
      accountno,
      paymentdate: moment(paymentdate).valueOf(),
      amount,
      savedraftValue: e.target.textContent && e.target.textContent.trim() === 'Submit Anyway'?  true: false
    });
  };
  return isShowing ? (
    <div>
      <div className="modal-overlay" id="paymentoption"></div>
      <div
        className="modal-wrapper"
        aria-modal
        aria-hidden
        tabIndex={-1}
        role="dialog"
      >
        <div className="modal" style={{ width: "125%" }}>
          <div
            className="modal-head-cross"
            onClick={(e) => {
              setShowTransactionDetails(false);
              setShowPaymentDetails(false);
              hide();
            }}
          >
            {!showPaymentDetails && !showTransactionDetails && (
              <p
                style={{
                  width: "100%",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                Payment Options
              </p>
            )}
            {showPaymentDetails && !showTransactionDetails && (
              <p
                style={{
                  width: "100%",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                Bank Details
              </p>
            )}
            {!showPaymentDetails && showTransactionDetails && (
              <p
                style={{
                  width: "100%",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                Transaction Details
              </p>
            )}

            <button
              type="button"
              className="modal-close-button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          {!showPaymentDetails && !showTransactionDetails && (
            <div>
              <div className="audio_raido_wrapper">
                <div className="own_radio">
                  <input
                    className="audio_input"
                    type="radio"
                    id="OwnRadio"
                    name="radio-group"
                    onClick={() => {
                      setpaymentmode("Online");
                    }}
                    checked={paymentmode === "Online" ? true : false}
                  />
                  <label className="audio_label" htmlFor="OwnRadio">
                    Online Payment
                  </label>
                </div>
                {/*<div className="own_radio or">OR</div>*/}
                <div className="own_radio">
                  <input
                    className="audio_input"
                    type="radio"
                    id="existingAudio"
                    name="radio-group"
                    onClick={() => {
                      setpaymentmode("Offline");
                    }}
                    checked={paymentmode === "Offline" ? true : false}
                  />
                  <label className="audio_label" htmlFor="existingAudio">
                    Offline Payment
                  </label>
                </div>
              </div>

              <button
                style={{
                  width: "220px",
                  backgroundColor: " #095DAB",
                  color: "#fff",
                  height: "40px",
                  fontSize: "16px",
                }}
                onClick={(e) => {
                  proceedPayment();
                }}
              >
                Proceed
              </button>
            </div>
            // <ul class="checkoutoptions">
            //   <li class="active" onClick={makePayment}>
            //     <a>Online Payment</a>
            //   </li>
            //   <li
            //     onClick={(e) => {
            //       setShowPaymentDetails(true);
            //     }}
            //   >
            //     <a>Offline Payment</a>
            //   </li>
            // </ul>
          )}

          {showPaymentDetails && !showTransactionDetails && (
            <React.Fragment>
              <p style={{ marginBottom: "10px" }}>
                To complete the transaction, make NEFT / RTGS / IMPS transfer of Rs. {payamount} /- to
              </p>
              <div style={{ border: "1px solid grey", padding: "5% 10%" }}>
                <div>
                  <span style={{ marginRight: "22%" }}>Account: </span>
                  <span style={{float: "inline-start" }}>
                  {accdetails.accountno}
                  </span>
                </div>
                <div>
                  <span style={{ marginRight: "26%" }}>IFSC:</span>{" "}
                  <span style={{ float: "inline-start" }}>
                  {accdetails.ifsc}
                  </span>
                </div>
                <div>
                  <span style={{ marginRight: "13%" }}>Beneficiary Name:</span>
                  <span style={{ float: "inline-start" }}>
                    {accdetails.name}
                  </span>
                </div>
              </div>
              <p
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  wordWrap: "break-word",
                }}
              >
                After payment, kindly submit the
                transaction details by clicking on "Enter Transaction Details"
              </p>
              <button
                style={{
                  width: "220px",
                  backgroundColor: " #095DAB",
                  color: "#fff",
                  height: "40px",
                  fontSize: "16px",
                }}
                onClick={(e) => {
                  setShowPaymentDetails(false);
                  setShowTransactionDetails(true);
                }}
              >
                Enter Transaction Details
              </button>
            </React.Fragment>
          )}
          {showTransactionDetails && !showPaymentDetails && (
            <React.Fragment>
              <table style={{ marginBottom: "10px" }}>
                <tr>
                  <td>
                    <label htmlFor="Account No">Your IFSC Code</label>
                  </td>
                  <td>
                    <input
                      type="ifsc"
                      name="ifsc code"
                      value={ifsc}
                      onChange={(e) => {
                        setifsc(e.target.value);
                      }}
                      placeholder="Enter your bank IFSC Code"
                      className="width200 inputBox"
                    />
                  </td>
                </tr>{" "}
                <tr>
                  <td>
                    <label htmlFor="Account No">Your Bank Account No</label>
                  </td>
                  <td>
                    <input
                      type="accno"
                      name="Account No"
                      value={accountno}
                      onChange={(e) => {
                        setaccountno(e.target.value);
                      }}
                      placeholder="Enter your Account Number"
                      className="width200 inputBox"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label htmlFor="Account No">Transaction Date</label>
                  </td>
                  <td>
                    <DatePicker
                      placeholderText="Select Transaction Date"
                      dateFormat="dd/MM/yyyy"
                      selected={paymentdate}
                      onSelect={setpaymentdate}
                      className="width200 inputBox"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label htmlFor="Account No">Transaction Ref No</label>
                  </td>
                  <td>
                    <input
                      type="refno"
                      name="Ref No"
                      placeholder="Enter the Reference Number"
                      value={refno}
                      onChange={(e) => {
                        setrefno(e.target.value);
                      }}
                      className="width200 inputBox"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label htmlFor="amount">Transaction Amount</label>
                  </td>
                  <td>
                    <input
                      type="amount"
                      name="amount"
                      value={amount}
                      onChange={(e) => {
                        setamount(e.target.value);
                      }}
                      placeholder="Enter the Transaction Amount"
                      className="width200 inputBox"
                    />
                  </td>
                </tr>
              </table>
              <button
                style={{
                  width: "220px",
                  backgroundColor: " #095DAB",
                  color: "#fff",
                  height: "40px",
                  fontSize: "16px",
                  marginRight: "10px",
                }}
                onClick={submitDetails}
              >
                Submit Transaction Details
              </button>
              {savedraft && (
                <button
                  style={{
                    width: "220px",
                    backgroundColor: " #095DAB",
                    color: "#fff",
                    height: "40px",
                    fontSize: "16px",
                  }}
                  onClick={submitDetails}
                >
                  Submit Anyway
                </button>
              )}
            </React.Fragment>
          )}
        </div>
      </div>
      <ToastContainer />
    </div>
  ) : null;
};

export default PaymentModel;



// WEBPACK FOOTER //
// ./web/components/campaign/paymentModel.js